import { Card, DebitAccount, Organisation, User } from '@generated-types';

const validateMod10 = (number: string): boolean => {
    const reverseNumber = [...number].slice(0, number.length - 1).reverse();
    let calc;
    let sum = 0;
    reverseNumber.forEach((val: any, i: number) => {
        calc = val * ((i + 1) % 2 ? 2 : 1);
        sum += Math.floor(calc / 10) + (calc % 10);
    });
    return Number(number.charAt(number.length - 1)) === (sum % 10 === 0 ? 0 : 10 - (sum % 10));
};

const validateMod11 = (number: string): boolean => {
    let sum = 0;
    [...number].forEach((val: any, i: number) => {
        if (i !== number.length - 1) {
            sum += (7 - ((i + 2) % 6)) * val;
        }
    });
    return Number(number.charAt(number.length - 1)) === (sum % 11 === 0 ? 0 : 11 - (sum % 11));
};

const validAccountModulo = (accountNumber: string | null | undefined) =>
    accountNumber && (validateMod10(accountNumber) || validateMod11(accountNumber));

const isValidAccountNumberLength = (accountNumber: string | null | undefined): boolean => {
    const elevenDigitsRegex = /^\d{11}$/;

    if (!accountNumber || !elevenDigitsRegex.test(accountNumber)) {
        return false;
    }

    return true;
};

export const isValidAccountNumber = (accountNumber: string | undefined | null): boolean => {
    if (typeof accountNumber === 'undefined') {
        return false;
    }

    if (isValidAccountNumberLength(accountNumber) && validAccountModulo(accountNumber)) {
        return true;
    }

    return false;
};

export const formatAccountNumber = (accountNumber: string): string => {
    const accountNumberParsed = accountNumber.replace(/[\s-]+/g, '');

    if (accountNumberParsed.length !== 11) {
        return accountNumberParsed;
    }

    const [a, b, c, d, e, f, g, h, i, j, k] = accountNumberParsed;
    return `${a}${b}${c}${d}.${e}${f}.${g}${h}${i}${j}${k}`;
};

export const getAccountNameUserCreated = ({ agreementName }: DebitAccount): string | null => agreementName ?? null;

export const getAccountName = ({ productName }: DebitAccount): string | undefined => productName;

export const getCardAccountNumber = ({ accountNumber }: Card): string => accountNumber;

export const isDebitAccount = (data: DebitAccount | undefined): data is DebitAccount => {
    return data !== undefined && 'externalId' in data;
};

export const isUser = (customer: User | Organisation | undefined): User | undefined => {
    if (customer && (customer as User).firstName !== undefined) {
        return customer as User;
    }
    return undefined;
};
